import {
  GET_ORG_GROUPS_REQUESTS_ERROR,
  GET_ORG_GROUPS_REQUESTS_SUCCESS,
  GET_ORG_GROUPS_REQUESTS_START,
} from 'constants/action-types/wallets/getOrgRequests';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORG_GROUPS_REQUESTS_START:
      return {
        ...state,
        orgGroupRequests: {
          ...state.orgGroupRequests,
          message: null,
          loading: true,
          error: null,
        },
      };
    case GET_ORG_GROUPS_REQUESTS_ERROR:
      return {
        ...state,
        orgGroupRequests: {
          ...state.orgGroupRequests,
          error: payload,
          loading: false,
          message: null,
        },
      };
    case GET_ORG_GROUPS_REQUESTS_SUCCESS:
      return {
        ...state,
        orgGroupRequests: {
          ...state.orgGroupRequests,
          items: payload.data,
          meta: payload.meta,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
